import React from 'react';

const Electronics = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title">Electronics and Robotics</h3>

            <div className="skills__box">
                <div className="skills__group">
                    <div className="skills__data"> 
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">Python</h3>
                            <span className="skills__level">Advanced</span>
                        </div>
                    </div>

                    <div className="skills__data"> 
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">Schematics and Datasheet analysis</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills__data"> 
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">SolidWorks</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills__data"> 
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">Arduino, ESP32, STM32, Rasberry Pi</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                    
                    <div className="skills__data"> 
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">Whireshark</h3>
                            <span className="skills__level">Basic</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Electronics;